import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { BookingSourcesResponseSchema } from "../schemas/dashboardV2Schemas";

const API_VERSION = 'v4';

const useDashboardBookingSources = (property_id?: string, month?: string | number) => {
    return useQuery({
        queryKey: ['dashboard-booking-sources', property_id, month],
        queryFn: async () => {
            const response = await privateApi.get(`/${API_VERSION}/dashboard/bookings/sources`, {
                params: { property_id, month }
            });
            const validationResult = BookingSourcesResponseSchema.safeParse(response.data);
            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid Booking Sources data format");
            }
            return validationResult.data;
        },
        enabled: !!property_id,
        retry: import.meta.env.VITE_MAX_RETRY ? parseInt(import.meta.env.VITE_MAX_RETRY as string) : 1,
        refetchOnWindowFocus: false
    });
};

export default useDashboardBookingSources;
